import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  const isAuthenticated = useMemo(() => {
    try {
      return Boolean(sessionStorage.getItem("token"));
    } catch (_) {
      return false;
    }
  }, []);

  const handleAction = () => {
    navigate(isAuthenticated ? "/dashboard" : "/", { replace: true });
  };
  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <div style={{ maxWidth: 560, width: "100%", textAlign: "center" }}>
        <img
          src="/img/404Error.png"
          alt="Page not found"
          style={{ width: 500, maxWidth: "100%" }}
          onError={e => {
            e.currentTarget.style.display = "none";
          }}
        />
        <h1
          style={{
            fontSize: 28,
            marginTop: "-50px",
            fontFamily: "Mulish, sans-serif"
          }}
        >
          Page not found
        </h1>
        <p
          style={{
            margin: 0,
            color: "#666",
            fontFamily: "Mulish, sans-serif"
          }}
        >
          The page you are looking for doesn’t exist or was moved.
        </p>
        {/*Action button */}
        <div
          style={{
            marginTop: 24,
            display: "flex",
            gap: 12,
            justifyContent: "center"
          }}
        >
          <button
            onClick={handleAction}
            style={{
              background: "rgb(255 209 2)",
              color: "black",
              border: "1px solid black",
              padding: "10px 16px",
              borderRadius: 8,
              fontWeight: 600,
              fontFamily: "Mulish, sans-serif",
              cursor: "pointer"
            }}
          >
            {isAuthenticated ? "Go to Dashboard" : "Go to Login"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
